import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-arch-modules',
	templateUrl:'./ModuleGraphPage.html',
	styles: [],
	styleUrls:['./ModuleGraphPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class ModuleGraphPage
{
	mdContent_30 = `Every JWebMP module declares its dependencies explicitly in \`module-info.java\`. The JPMS module graph ensures clean boundaries — no classpath hell, no hidden dependencies, no runtime surprises.`;
	mdContent_31 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph TD
  CORE["com.jwebmp.core"]

  subgraph JWEBMP["JWebMP Layer"]
    CLIENT["com.jwebmp.client<br/><i>SPI contracts, AJAX</i>"]
  end

  subgraph GUICEDEE["GuicedEE Layer"]
    GUICEE["com.guicedee.client<br/><i>DI, lifecycle, CallScope</i>"]
    VERTX["com.guicedee.vertx<br/><i>Vert.x lifecycle</i>"]
  end

  subgraph RUNTIME["Runtime Libraries"]
    VXC["io.vertx.core"]
    VXW["io.vertx.web"]
    GUICE["com.google.guice"]
    JACKSON["com.fasterxml.jackson"]
  end

  subgraph SPECS["Jakarta Specs"]
    JAKARTA["jakarta.validation"]
    COMMONS["org.apache.commons"]
  end

  CORE ==> CLIENT
  CORE ==> GUICEE
  CORE ==> VERTX
  GUICEE --> GUICE
  VERTX --> VXC
  VERTX --> VXW
  CORE -.-> JACKSON
  CORE -.-> JAKARTA
  CORE -.-> COMMONS

  style JWEBMP fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0
  style GUICEDEE fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style RUNTIME fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style SPECS fill:#3b1a1a,stroke:#f87171,stroke-width:2px,color:#e2e8f0

\`\`\``;
}
